import {React,useState,useEffect} from "react";
import { toast } from 'react-toastify';
import ReactLoading from 'react-loading';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import {useHistory } from 'react-router-dom'

import './CheckPhone.scss'
import { useDispatch,useSelector } from "react-redux";
import { getData } from "../Services/APIService";
import { updateCustomer } from "../../ReduxActions/customerAction";
import { changeNumbers,changeNumbersToEnglish } from "../Common/regex";
import JButton from '../../components/Button/JButton'

const CheckPhone= () => {

    const dispatch = useDispatch();
    const customer = useSelector(state => state.customer);

    const [getPhone,setPhone] = useState(customer.PhonePure);
    const [getPrePhone,setPrePhone] = useState(customer.PrePhone);
    const [getLoading,setLoading] = useState(false);

    const [getRegion,setRegion] = useState("");
    const [getCity,setCity] = useState("");
    const [getStation,setStation] = useState("");
    const [getCoverage,setCoverage] = useState(0);
    const [showPopup,setShowPopup] = useState(false);

    const history = useHistory();

    useEffect( () => {
        //dispatch(updateCustomer({checkPhone:-1,phone:""}));
        window.scrollTo(0, 0);

    },[]);

    const handlePhoneChanged= ({ target }) =>{
        setPhone(target.value);
        
        dispatch(updateCustomer({checkPhone:-1}));
    }

    const handlePrePhoneChanged= ({ target }) =>{
        setPrePhone(target.value);
        dispatch(updateCustomer({checkPhone:-1}));
    }

    const handleCheckStatus= async (e) =>{
        e.preventDefault();

        setLoading(true);

        // const phone=changeNumbers(getPrePhone.substring(1,3).concat(getPhone));
        const phone=changeNumbersToEnglish(getPrePhone.substring(1,3).concat(getPhone));
        const info={
            phone
         };

        try{
            const {data}=await getData('store/CoverageFCP',info);
            console.log("StoreLog: ",data);

            if (data.Result !== 4 && data.Message!== null) {
                toast.error(data.Message,{
                    position:'bottom-left',
                    closeButton:true,
                    closeOnClick:true
                })
            }
            else if (data.Result !== 4) {
                toast.error("خطایی رخ داده است",{
                    position:'bottom-left',
                    closeButton:true,
                    closeOnClick:true
                }) 
            }
            else if (data.Coverage === 2) {
                setShowPopup(true);
                setCoverage(data.Coverage);
                dispatch(updateCustomer({checkPhone:data.Coverage,Phone:phone,PhonePure:getPhone,PrePhone:getPrePhone}));
            }
            else if (data.Coverage === 0) {
                setCoverage(data.Coverage);
                dispatch(updateCustomer({checkPhone:data.Coverage,Phone:phone,PhonePure:getPhone,PrePhone:getPrePhone}));
                history.push("/serviceShow");
            }
            else{
                setCoverage(data.Coverage);
                setRegion(data.regionName);
                setCity(data.cityName);
                setStation(data.stationName);

                dispatch(updateCustomer({checkPhone:data.Coverage,Phone:phone,PhonePure:getPhone,PrePhone:getPrePhone}));
            }
        }
        catch(ex){
            toast.error("مشکلی پیش آمده.", {
                position: "bottom-left",
                closeOnClick: true
            });
        }

        setLoading(false);
    }

    return ( 
        <div className="checkPhone">
            <Modal classNames={{closeIcon:"modalClose",modal:"modal"}} open={showPopup} onClose={() => setShowPopup(false)} center>
                <div className="modalIconP">
                    <div className="modalIcon">
                        <label className="fa fa-info"></label>
                    </div>
                </div>
                <label className="modalTitle">دوست گرامی</label>
                <div className="modalBody">
                    <label className="modalLabel">
                        خط تلفن شما هم اینک در سیستم مدیریت ارتباط با مشتریان ماهان نت ثبت شده است، برای دریافت اطلاعات بیشتر به حساب کاربری خود مراجعه کنید.
                    </label>
                    
                    <div className="btnProfileLogin">
                        <a href="http://my.mahannet.ir" target="_blank">ورود به پروفایل</a>
                    </div>
                </div>
            </Modal>
            <label className="lblCovering">برای بررسی پوشش دهی ADSL لطفا کد شهر و شماره تلفن را وارد نمایید</label>
            <div className="checkPhoneS">
                <div className="lblPhones">
                    <div className="lblPhone">
                        <div/>
                        <span> شماره تلفن</span>&nbsp;
                    </div>
                    <div className="lblPrePhone">
                        <div/>
                        <span>پیش شماره </span>
                    </div>
                </div>
                <div className="txtPhones">
                    <input type="text" className="txtPhone"  placeholder="لطفا شماره تلفن خود را وارد نمایید" value={changeNumbers(getPhone)} onChange={ handlePhoneChanged }></input>
                    <input type="text" className="txtPrePhone"  placeholder="کد 3 رقمی استان" value={changeNumbers(getPrePhone)} onChange={ handlePrePhoneChanged }></input>
                </div>
                {/* <div className="btnCheck" onClick={handleCheckStatus}>
                    <span>
                        {
                            !getLoading ? "بررسی وضعیت" :
                            <ReactLoading type="bubbles" color={"#ff8035"} />
                        }
                    </span>
                    
                </div> */}
                <div className="btnCheck">
                    <JButton title={!getLoading ? "بررسی وضعیت" : <ReactLoading type="bubbles" color={"#ff8035"} />} handleClick={handleCheckStatus} type={"ADSL"} />
                </div>
            </div>

            {getCoverage === 1 ?
            <div className="checkingResult">
                <div className="checkingResultItem" id="divRegion">
                    <label>استان</label>
                    <span>{getRegion}</span>
                </div>
                <div className="divSep"></div>
                <div className="checkingResultItem" id="divCity">
                    <label>شهر</label>
                    <span>{getCity}</span>
                </div>
                <div className="divSep"></div>
                <div className="divSep2"></div>
                <>
                <div className="checkingResultItem" id="divStation">
                    <label>مرکز</label>
                    <span>{getStation}</span>
                </div>
                <div className="divSep"></div>
                <div className="checkingResultItem" id="divStatus">
                    <label>وضعیت</label>
                    <span className="colorGreen">تحت پوشش</span>
                </div>
                </>
            </div>
            :null
            }
        </div>
     );
}

export default CheckPhone;
